module.exports = __webpack_public_path__ + "static/media/familia.4235cc3b.jpg";